<template>
  <div
    class="new-design"
    id="new-design"
    data-sidebar="0"
    data-position="0"
    data-name="新设计"
  >
    <template v-if="isPC">
      <div class="title-block">
        <AnimationText
          v-if="isPC"
          class="ffm600"
          text="新设计，光鲜亮丽"
          backgroundColor="rgba(0, 0, 0, 0.1)"
          :themeColor="['#ED3E5B','#D54540','#F19A5C']"
          originLinerCssStyle="linear-gradient(270deg, #ED3E5B 0%, #D54540 21%, #F19A5C 100%)"
          endColor="#F19A5C"
          :fontSize="96"
          :fontWeight="600"
          :lineHeight="115"
          :startTrigger="`top+=115 bottom`"
          :endTrigger="'top 10%'"
          :activateRatio="0"
          :activateDelay="200"
        />
        <!-- <p class="slogan ffm600">新设计，光鲜亮丽</p> -->
      </div>
      <div
        id="light-space"
        class="light-space"
        ref="lightSpace"
        data-position="1"
        data-name="光影空间"
      >
        <PlusImage class="ls-bg" :src="NEW_DESIGN.bg" alt="" />
        <div class="ls-content">
          <p class="flag-text ffm500">光影空间</p>
          <p class="title-text ffm600">细节之处，遇见微光</p>
          <p class="subtitle-text ffm400">
            全新的光影空间，让你感受到系统每个细节的秩序与真实，也让你沉浸其中。
            在光的作用下，包括色彩、字符和材质，都沾上了光的灵动与温度。
          </p>
          <div class="phone-model" :class="{ 'fade-in-slide-up': show }">
            <PlusImage :src="NEW_DESIGN.phoneModel" alt="" />
            <video ref="video" :src="VIDEOS.lightSpace" muted autoplay></video>
          </div>
        </div>
      </div>
      <div class="nd-swiper" ref="ndSwiper" data-position="2" data-name="通知堆叠">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <PlusImage class="slide1-img" :src="NEW_DESIGN.slide1" alt="" />
            <div class="text-box">
              <p class="subtitle">通知堆叠</p>
              <p class="title">叠起来，更好看</p>
              <p class="content">
                通知整齐叠放 ，界面更具空间感。内容再多也不乱，重点自然更好看。
              </p>
            </div>
          </div>
          <div class="swiper-slide">
            <PlusImage class="slide2-img" :src="NEW_DESIGN.slide2" alt="" />
            <div class="text-box">
              <p class="subtitle">渐进模糊</p>
              <p class="title">界面过渡更自然</p>
              <p class="content">
                全新的渐进模糊效果，让界面元素与背景的分离像烟雾般轻盈过渡，画面更通透、沉浸。 
              </p>
            </div>
          </div>
          <div class="swiper-slide">
            <PlusImage
              class="slide3-img"
              :src="NEW_DESIGN.x300PhoneModel"
              alt=""
            />
            <video muted class="nd-ai-light" :src="VIDEOS.ndaiLight"></video>
            <div class="text-box">
              <p class="subtitle">AI光效</p>
              <p class="title">从思考，到闪耀</p>
              <p class="content">你与小V的每一次互动，都有光影回应。</p>
            </div>
          </div>
        </div>
        <div class="pagination">
          <ul>
            <li
              v-for="(item, i) of 3"
              :key="i"
              :class="{ active: activeIndex == i }"
            ></li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="title-block" v-animate>
        <p v-if="isPad" class="slogan ffm600">新设计，光鲜亮丽</p>
        <p v-else class="slogan ffm600">新设计<br />光鲜亮丽</p>
      </div>
      <div
        class="light-space"
        ref="lightSpace"
        data-position="1"
        data-name="光影空间"
        v-animate:threshold="0.1"
      >
        <PlusImage
          v-if="isPad"
          class="ls-bg"
          :src="NEW_DESIGN.ls676bg"
          alt=""
        />
        <PlusImage v-else class="ls-bg" :src="NEW_DESIGN.ls360bg" alt="" />
        <div class="ls-content">
          <p class="flag-text ffm500">光影空间</p>
          <p class="title-text ffm600">细节之处，遇见微光</p>
          <p class="subtitle-text ffm400">
            全新的光影空间，让你感受到系统每个细节的秩序与真实，也让你沉浸其中。在光的作用下，包括色彩、字符和材质，都沾上了光的灵动与温度。
          </p>
        </div>
      </div>
      <div class="nd-swiper" data-position="2" data-name="通知堆叠">
        <div class="swiper-slide" v-animate>
          <PlusImage
            v-if="isPad"
            class="slide-bg"
            :src="NEW_DESIGN.padSlide1"
            alt=""
          />
          <PlusImage
            v-else
            class="slide-bg"
            :src="NEW_DESIGN.h5Slide1"
            alt=""
          />
          <div class="text-box">
            <p class="subtitle">通知堆叠</p>
            <p class="title">叠起来 更好看</p>
            <p class="content">
              通知整齐叠放 ，界面更具空间感。内容再多也不乱，重点自然更好看。
            </p>
          </div>
        </div>
        <div class="swiper-slide" v-animate>
          <PlusImage
            v-if="isPad"
            class="slide-bg"
            :src="NEW_DESIGN.padSlide2"
            alt=""
          />
          <PlusImage
            v-else
            class="slide-bg"
            :src="NEW_DESIGN.h5Slide2"
            alt=""
          />
          <div class="text-box">
            <p class="subtitle">渐进模糊</p>
            <p class="title">界面过渡更自然</p>
            <p class="content">
              全新的渐进模糊效果，让界面元素与背景的分离像烟雾般轻盈过渡，画面更通透、沉浸。
            </p>
          </div>
        </div>
        <div class="swiper-slide" v-animate>
          <PlusImage
            v-if="isPad"
            class="slide-bg"
            :src="NEW_DESIGN.padSlide3"
            alt=""
          />
          <PlusImage
            v-else
            class="slide-bg"
            :src="NEW_DESIGN.h5Slide3"
            alt=""
          />
          <div class="text-box">
            <p class="subtitle">AI光效</p>
            <p class="title">从思考，到闪耀</p>
            <p class="content">你与小V的每一次互动，都有光影回应。</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "swiper/css";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import { initExposureTrack } from "@/utils/track.js";
import { NEW_DESIGN } from "@/config/image.js";
import VIDEOS from "@/config/video.js";
import AnimationText from "@/components/AnimationText.vue";
import { gsap, ScrollTrigger } from "@/utils/gsapConfig";

export default {
  name: "NewDesign",
  components: {
    AnimationText,
  },
  data() {
    return {
      NEW_DESIGN,
      VIDEOS,
      show: false,
      activeIndex: 0,
      themeColor: ["#F19A5C", "#D54540", "#ED3E5B"],
      colorPosition: [0, 79, 100],
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  mounted() {
    this.isFirst = true;
    initExposureTrack(".new-design [data-position]")();
    if (this.isPC) {
      this.aiVideo = this.$el.querySelector(".nd-ai-light");
      // this.initScrollColorAnimation();
      this.initObserver();
      this.initSwiper();
      this.initGsap();
    }
  },
  methods: {
    initScrollColorAnimation() {
      // 获取标语元素
      const sloganElement = this.$el.querySelector(".slogan");
      if (sloganElement) {
        // 创建ScrollTrigger动画
        gsap.to(sloganElement, {
          scrollTrigger: {
            id: "sloganScrollTrigger",
            trigger: sloganElement,
            start: "top 90%", // 当元素顶部距离视口顶部90%时开始动画
            end: "bottom 50%", // 当元素底部距离视口顶部50%时结束动画
            scrub: 1, // 动画与滚动同步，数值越大越平滑
            // markers: true,
            toggleActions: "play none none reverse", // 进入、离开、重新进入、重新离开时的动作
            onUpdate: (self) => {
              // 根据滚动进度动态改变文字渐变效果
              const progress = self.progress;
              // 计算渐变位置，从左到右移动
              const gradientPosition = progress * 100;
              // 创建从灰色到最终双层渐变的过渡效果
              // 已滚动过的部分显示彩色，未滚动到的部分保持灰色
              const finalGradient = `linear-gradient(90deg, 
                #F19A5C 0%, 
                #D54540 ${(79 * gradientPosition) / 100}%, 
                #ED3E5B ${(100 * gradientPosition) / 100}%, 
                #eee ${gradientPosition}%, 
                #eee 100%)`;
              // 应用渐变背景并设置文字裁剪
              sloganElement.style.background = finalGradient;
            },
          },
        });
      }
    },
    initObserver() {
      const video = this.$refs.video;
      const observeDom = this.$refs.lightSpace;
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (this.isFirst && entry.isIntersecting) {
            video
              .play()
              .then(() => {})
              .catch((e) => {
                console.error(e);
              });
            this.isFirst = false;
            this.show = true;
          }
        });
      };
      const observer = new IntersectionObserver(callback, {
        root: null,
        rootMargin: "0px",
        threshold: 0.9,
      });
      observer.observe(observeDom);
    },
    initSwiper() {
      const that = this;
      this.swiper = new Swiper(".nd-swiper", {
        slidesPerView: "auto",
        spaceBetween: 24,
        centeredSlides: true,
        allowTouchMove: false,
        on: {
          slideChange: function (swiper) {
            that.activeIndex = swiper.activeIndex;
          },
        },
      });
    },
    initGsap() {
      let aiVideoPlay = false;
      const height = this.$refs.ndSwiper.clientHeight
      gsap.to(".new-design", {
        scrollTrigger: {
          id: "swiperScrollTrigger",
          trigger: ".nd-swiper", // 触发滚动的元素
          start: "top 20px", // 元素底部进入视口底部时触发
          end: `top+=${height*2} 20px`, // 
          pin: true,
          anticipatePin: 1, // 在定格前预先触发的距离
          scrub: true, // 使得元素滚动时，滚动速度等于页面滚动速度
          // markers: true,
          onUpdate: (self) => {
            // 计算当前滚动位置占总滚动距离的比例
            const progress = self.progress;
            if (progress > 0.25) {
              if (progress > 0.75) {
                this.swiper.slideTo(2);
                this.aiVideo &&
                  !aiVideoPlay &&
                  this.$el.querySelector(".nd-ai-light").play();
                aiVideoPlay = true;
                return;
              }
              this.swiper.slideTo(1);
              aiVideoPlay = false;
            } else {
              this.swiper.slideTo(0);
              aiVideoPlay = false;
            }
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.new-design {
  background: #fff;
  position: relative;
  .title-block {
    height: 350 * $px1920vw + vw;
    display: flex;
    align-items: center;
    justify-content: center;
    .slogan {
      font-size: 96 * $px1920vw + vw;
      line-height: 115 * $px1920vw + vw;
      text-align: center;
      letter-spacing: normal;
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
      background-clip: text !important;
      text-fill-color: transparent !important;
    }
  }
  .light-space {
    height: 900 * $px1920vw + vw;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    .ls-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .ls-content {
      position: absolute;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      z-index: 2;
      .flag-text {
        margin-top: 46 * $px1920vw + vw;
        font-size: 28 * $px1920vw + vw;
        color: rgba(0, 0, 0, 0.8);
        margin-bottom: 12 * $px1920vw + vw;
      }
      .title-text {
        width: auto;
        font-size: 64 * $px1920vw + vw;
        font-weight: 600;
        line-height: 76.8 * $px1920vw + vw;
        letter-spacing: normal;
        background: linear-gradient(
            270deg,
            rgba(0, 0, 0, 0.65) 0%,
            rgba(0, 0, 0, 0.83) 39%,
            #606060 72%
          ),
          #000000;
        background-clip: text;
        margin-bottom: 24 * $px1920vw + vw;
        -webkit-text-fill-color: transparent;
      }
      .subtitle-text {
        width: 612 * $px1920vw + vw;
        color: rgba(0, 0, 0, 0.6);
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
      }
      .phone-model {
        flex-shrink: 0;
        margin-top: 80 * $px1920vw + vw;
        position: relative;
        width: 968 * $px1920vw + vw;
        height: 774.18 * $px1920vw + vw;
        transition: all ease-in-out 0.75s;
        // opacity: 0.5;
        transform: translateY(100 * $px1920vw + vw);
        &.fade-in-slide-up {
          transform: none;
          opacity: 1;
        }
        picture,
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          z-index: 2;
        }
        video {
          position: absolute;
          left: 16.92vw;
          top: 0.55vw;
          width: 315.84 * $px1920vw + vw;
          height: 685.71 * $px1920vw + vw;
          z-index: 1;
          border-radius: 40 * $px1920vw + vw;
        }
      }
    }
  }
  .nd-swiper {
    height: 956 * $px1920vw + vw;
    padding: 120 * $px1920vw + vw 0;
    .swiper-wrapper {
      height: 650 * $px1920vw + vw;
      .swiper-slide {
        width: 980 * $px1920vw + vw;
        height: 650 * $px1920vw + vw;
        border-radius: 24 * $px1920vw + vw;
        position: relative;
        picture,
        img,
        video,
        .text-box {
          position: absolute !important;
        }
        .text-box {
          text-align: left;
          .subtitle {
            font-size: 24 * $px1920vw + vw;
            font-family: "vivoSansSCVF500";
            font-weight: 500;
            line-height: 28.8 * $px1920vw + vw;
            margin-bottom: 8 * $px1920vw + vw;
          }
          .title {
            font-size: 32 * $px1920vw + vw;
            font-family: "vivoSansSCVF600";
            font-weight: 600;
            line-height: 38.4 * $px1920vw + vw;
            margin-bottom: 24 * $px1920vw + vw;
          }
          .content {
            font-size: 18 * $px1920vw + vw;
            line-height: 25.2 * $px1920vw + vw;
            color: rgba(0, 0, 0, 0.6);
          }
        }
        &:nth-child(1) {
          background: #f5f5f7;
          padding: 0 48 * $px1920vw + vw 48 * $px1920vw + vw;
          .slide1-img {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
          .text-box {
            width: calc(100% - 96px);
            bottom: 48 * $px1920vw + vw;
            left: 48 * $px1920vw + vw;
          }
        }
        &:nth-child(2) {
          background: linear-gradient(180deg, #ffd292 0%, #f5f5f7 100%);
          padding: 48 * $px1920vw + vw 48 * $px1920vw + vw 0;
          .slide2-img {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
          .text-box {
            width: calc(100% - 96px);
            top: 48 * $px1920vw + vw;
            left: 48 * $px1920vw + vw;
          }
        }
        &:nth-child(3) {
          background: url("@/assets/nd-slide-bg.png");
          background-size: 100% 100%;
          padding: 48 * $px1920vw + vw;
          color: #fff;
          .slide3-img {
            width: 260 * $px1920vw + vw;
            height: 540 * $px1920vw + vw;
            top: 54 * $px1920vw + vw;
            right: 170 * $px1920vw + vw;
            z-index: 2;
          }
          .nd-ai-light {
            width: 241.53 * $px1920vw + vw;
            height: 524.37 * $px1920vw + vw;
            top: 3.15vw;
            right: 9.39vw;
            z-index: 1;
            border-radius: 1.5vw;
          }
          .text-box {
            width: 325 * $px1920vw + vw;
            top: 50%;
            transform: translateY(-50%);
            left: 48 * $px1920vw + vw;
            .content {
              color: rgba(255, 255, 255, 0.8);
            }
          }
        }
      }
    }
    .pagination {
      width: 140 * $px1920vw + vw;
      height: 42 * $px1920vw + vw;
      background: #f5f5f7;
      border-radius: 21 * $px1920vw + vw;
      margin: 24 * $px1920vw + vw auto 0 auto;
      padding: 15 * $px1920vw + vw 17 * $px1920vw + vw;
      display: flex;
      align-items: center;
      justify-content: center;
      ul {
        font-size: 0;
        margin: 0;
        padding: 0;
        li {
          width: 7 * $px1920vw + vw;
          height: 7 * $px1920vw + vw;
          border-radius: 3.5 * $px1920vw + vw;
          background: rgba(0, 0, 0, 0.5);
          margin-right: 14 * $px1920vw + vw;
          display: inline-block;
          transition: width ease-in-out 0.5s;
          &:last-child {
            margin-right: 0;
          }
          &.active {
            width: 54 * $px1920vw + vw;
          }
        }
      }
    }
  }
}
.isPad,
.isMobile {
  .new-design {
    .title-block {
      height: 180 * $px676vw + vw;
      .slogan {
        font-size: 42 * $px676vw + vw;
        line-height: normal;
        background: linear-gradient(
          270deg,
          #ed3e5b 0%,
          #d54540 21%,
          #f19a5c 100%
        );
      }
    }
    .light-space {
      height: 530 * $px676vw + vw;
      .ls-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      .ls-content {
        .flag-text {
          font-size: 12 * $px676vw + vw;
          margin-bottom: 6 * $px676vw + vw;
          margin-top: 46 * $px676vw + vw;
        }
        .title-text {
          width: auto;
          font-size: 25 * $px676vw + vw;
          line-height: normal;
          margin-bottom: 12 * $px676vw + vw;
        }
        .subtitle-text {
          width: 286 * $px676vw + vw;
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
        }
      }
    }
    .nd-swiper {
      height: auto;
      background: #fff;
      padding: 36 * $px676vw + vw 40 * $px676vw + vw;
      box-sizing: border-box;
      .swiper-slide {
        width: 100%;
        height: 300 * $px676vw + vw;
        border-radius: 16 * $px676vw + vw;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20 * $px676vw + vw;
        &:nth-child(1) {
          padding-left: 36 * $px676vw + vw;
          .text-box {
            width: 231 * $px676vw + vw;
          }
        }
        &:nth-child(2) {
          padding-right: 36 * $px676vw + vw;
          flex-direction: row-reverse;
          .text-box {
            width: 226 * $px676vw + vw;
          }
        }
        &:nth-child(3) {
          margin-bottom: 0;
          padding-left: 36 * $px676vw + vw;
          .text-box {
            width: 277 * $px676vw + vw;
            .subtitle {
              color: #fff;
            }
            .title {
              color: #fff;
            }
            .content {
              color: rgba(255, 255, 255, 0.6);
            }
          }
        }
        .slide-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .text-box {
          position: absolute;
          z-index: 2;
          text-align: left;
          .subtitle {
            font-size: 12 * $px676vw + vw;
            font-family: "vivoSansSCVF500";
            font-weight: 500;
            margin-bottom: 6 * $px676vw + vw;
          }
          .title {
            font-size: 20 * $px676vw + vw;
            font-family: "vivoSansSCVF600";
            font-weight: 600;
            margin-bottom: 12 * $px676vw + vw;
          }
          .content {
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
    }
  }
}
.isMobile {
  .new-design {
    .title-block {
      height: 180 * $px360vw + vw;
      .slogan {
        width: 100%;
        font-size: 42 * $px360vw + vw;
        text-align: center;
        background: linear-gradient(
          270deg,
          #ed3e5b 0%,
          #d54540 21%,
          #f19a5c 100%
        );
        line-height: normal;
      }
    }
    .light-space {
      height: 505 * $px360vw + vw;
      .ls-content {
        .flag-text {
          font-size: 12 * $px360vw + vw;
          margin-bottom: 6 * $px360vw + vw;
          margin-top: 46 * $px360vw + vw;
        }
        .title-text {
          width: auto;
          font-size: 25 * $px360vw + vw;
          margin-bottom: 12 * $px360vw + vw;
        }
        .subtitle-text {
          width: 286 * $px360vw + vw;
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
        }
      }
    }
    .nd-swiper {
      padding: 36 * $px360vw + vw 20 * $px360vw + vw;
      .swiper-slide {
        height: 360 * $px360vw + vw;
        border-radius: 0;
        margin-bottom: 20 * $px360vw + vw;
        align-items: start;
        &:nth-child(1) {
          padding: 0 22 * $px360vw + vw 30 * $px360vw + vw;
          align-items: end;
        }
        &:nth-child(2) {
          padding: 36 * $px360vw + vw 22 * $px360vw + vw 0;
          flex-direction: row;
        }
        &:nth-child(3) {
          margin-bottom: 0;
          padding: 36 * $px360vw + vw 22 * $px360vw + vw 0;
        }
        .text-box {
          width: calc(100% - 12.22vw) !important;
          .subtitle {
            font-size: 12 * $px360vw + vw;
            margin-bottom: 6 * $px360vw + vw;
          }
          .title {
            font-size: 20 * $px360vw + vw;
            margin-bottom: 12 * $px360vw + vw;
          }
          .content {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
          }
        }
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .new-design {
      background: #000;
      .nd-swiper {
        background: #000;
      }
    }
  }
}
</style>
